import React from 'react';
import styled from '@emotion/styled';
import { NavLink as BaseNavLink } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NavLink = styled(BaseNavLink)<any>`
  padding: 10px 20px;
  border-radius: 8px;
  border: 1.5px solid transparent;
  font-size:20px;
  font-weight: 400;
  line-height: 100%;
  letter-spacing: 1px;
  white-space: nowrap;
  border-color: ${(props) => props.theme.colors.gray};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: ${(props) => props.theme.colors.primaryColor};
  }
  &.active {
    background-color: ${(props) => props.theme.colors.primaryColor};
    border-color: ${(props) => props.theme.colors.primaryColor};
    color: ${(props) => props.theme.colors.secondaryTextColor};
  }
  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function NavLinkButton({ children, ...props }: any) {
  return (
    <NavLink className={props?.disabled ? 'disabled' : '' } {...props}>
      {children}
    </NavLink>
  );
}